import { DefaultState } from 'store/reducers/types';

export const READ_FUTURE_WORK_BY_CLIENT_DATA_REQUEST = "READ_FUTURE_WORK_BY_CLIENT_DATA_REQUEST";
export const READ_FUTURE_WORK_BY_CLIENT_DATA_SUCCESS = "READ_FUTURE_WORK_BY_CLIENT_DATA_SUCCESS";
export const READ_FUTURE_WORK_BY_CLIENT_DATA_FAILURE = "READ_FUTURE_WORK_BY_CLIENT_DATA_FAILURE";

export interface FutureWorkByClientRow {
  assignedPending: number;
  assignedUnconfirmed: number;
  backupCount: number;
  clientId: number;
  clientName: string;
  didNotConfirm: number;
  filled: string;
  leftCount: number;
  needed: number;
  onHold: number;
  pendingAssignment: number;
  repHasApplied: number;
};

export interface FutureWorkByClientData {
  rows: FutureWorkByClientRow[] | [];
  totalCount: number;
};

export type FutureWorkByClientState = DefaultState & {
  contents?: FutureWorkByClientData;
};

interface ReadFutureWorkByClientDataRequest {
  type: typeof READ_FUTURE_WORK_BY_CLIENT_DATA_REQUEST;
};

interface ReadFutureWorkByClientDataSuccess {
  type: typeof READ_FUTURE_WORK_BY_CLIENT_DATA_SUCCESS,
  contents: FutureWorkByClientData
}

interface ReadFutureWorkByClientDataFailure {
  type: typeof READ_FUTURE_WORK_BY_CLIENT_DATA_FAILURE;
}

export type FutureWorkByClientActionTypes = ReadFutureWorkByClientDataRequest | ReadFutureWorkByClientDataSuccess | ReadFutureWorkByClientDataFailure;
  